import styled from 'styled-components';
import {
  Icon as SemanticIcon,
  Image,
} from 'semantic-ui-react';

export const CloseButton = styled.div`
  display: block;
  position: absolute;
  background-color: #696969;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  top: -8px;
  right: -8px;
  cursor: pointer;

  &:hover {
    background-color: #888888;
  }

  &:active {
    background-color: #696969;
  }
`;

export const Container = styled.div`
  display: flex;
  position: relative;

`;

export const ImagePreview = styled(Image)`
  &&.ui.image {
    max-width: 90px;
    max-height: ${(props) => props.maxHeight ?? '60px'};
  }
`;

export const Icon = styled(SemanticIcon)`
  &&& {
    color: white;
    font-size: 11px;
    width: 13px;
    height: 13px;
    position: absolute;
    top: -1px;
    right: -2px;
  }
`;
